<template>
  <div>
    <div style="width: 80%; margin-left: 10%;">
      <div style="display: flex;flex-direction: column;align-items: center;">
        <h1><span>{{stu_name}}的</span>儿童康复档案列表 {{stu_type}} ({{year}}年度)</h1>
      </div>
      <!-- 基本资料 -->
      <el-card id="id1">
        <div slot="header" class="clearfix">
          <span>基本资料信息</span>

        </div>
        <div>
          <el-descriptions title="基本信息" :column="4" size="" border>
            <template slot="extra" v-if="false">
              <el-button type="primary" size="small">操作</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                姓名
              </template>
              {{ stu_info_zt.stu_name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                身份证号
              </template>
              {{ stu_info_zt.stu_ID }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                性别
              </template>
              {{ stu_info_zt.stu_sex }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                民族
              </template>
              {{ stu_info_zt.minzu }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                出生日期
              </template>
              {{ stu_info_zt.shengri }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                民族
              </template>
              {{ stu_info_zt.minzu }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                家庭住址
              </template>
              {{ stu_info_zt.stu_home }}
            </el-descriptions-item>
          </el-descriptions>
          <!--基本信息结束-->
          <el-descriptions class="margin-top" title="残疾人证信息" :column="2" size="" border>
            <template slot="extra" v-if="false">
              <el-button type="primary" size="small">操作</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                残疾人证
              </template>
              {{ stu_info_zt.canjiren_zheng }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                残疾人证号
              </template>
              {{ stu_info_zt.canji_idchard}}
            </el-descriptions-item>
          </el-descriptions>
          <!--残疾信息结束-->
          <el-descriptions class="margin-top" title="诊断信息" :column="3" size="" border>
            <template slot="extra" v-if="false">
              <el-button type="primary" size="small">操作</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                诊断
              </template>
              {{ stu_info_zt.stu_zhenduan }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                诊断医院
              </template>
              {{ stu_info_zt.stu_zhenduan_yiyuan }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                诊断时间
              </template>
              {{ stu_info_zt.stu_zhenduan_time }}
            </el-descriptions-item>
          </el-descriptions>
          <!--诊断信息结束-->
          <el-descriptions class="margin-top" title="诊断结果" :column="3" size="" border>
            <template slot="extra" v-if="false">
              <el-button type="primary" size="small">操作</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                肢体残疾类别
              </template>
              {{stu_info_zt.dianji_canjifenlei_shuju}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                是否伴有其他障碍
              </template>
              {{ stu_info_zt.dianji_qita_shuju }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                致残时间
              </template>
              {{ stu_info_zt.dianji_zhican_shuju }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                致残原因
              </template>
              {{ stu_info_zt.dianji_zhican_yuanyin_info }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                既往医疗、康复情况
              </template>
              {{ stu_info_zt.dianji_yiliaoqingkuang_info }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                康复医师或训练人员签名
              </template>
              {{ stu_info_zt.physician }}
            </el-descriptions-item>
          </el-descriptions>
          <!-- <div class="el-descriptions__title margin-top">
            监护人信息
          </div> -->
          <el-table class="margin-top" :data="famliy_info" border style="width: 100%">
            <el-table-column prop="guanxi" label="关系" width="180">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="idcard" label="身份证号">
            </el-table-column>
            <el-table-column prop="phone" label="手机号">
            </el-table-column>
          </el-table>
          <div class="el-descriptions__title margin-top">
            情况说明
          </div>
          <el-input class="margin-top" style="font-size: 16px;" type="textarea" :rows="5" disabled
            v-model="stu_info_zt.illustrate">
          </el-input>
        </div>
      </el-card>
      <div style="height: 50px;width: 200px;"></div>
      <!-- 训练评估 -->
      <el-card id="id2">
        <div slot="header" class="clearfix">
          <span> 训练评估</span>

        </div>
        <div v-if="stu_xp!=null&&stu_xp.length!=0">
          <div v-for="(item,index) in stu_xp" :key="index">
            <div slot="header" class="clearfix margin-top">
              <span>{{"第"+"一二三四".charAt(item.zt_xp_tab)+"次评估"}}</span>
            </div>
            <el-table class="margin-top" :data="item.zt_conent_ly" border>
              <el-table-column label="领域" prop="list">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.list.split("-")[0]}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="项目" prop="list">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.list.split("-")[1]}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="评分依据" prop="list">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.list.split("-")[2]}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="评估计分" prop="list">
                <template slot-scope="scope">
                  <span>
                    {{scope.row.list.split("-")[3]}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-descriptions class="margin-top" title="分值" :column="3" border>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  {{item.zt_xp_sum_ly[0].name==undefined?"运动功能":item.zt_xp_sum_ly[0].name}}
                </template>
                {{ item.zt_xp_sum_ly[0].value==undefined?"0":item.zt_xp_sum_ly[0].value }}分
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  {{item.zt_xp_sum_ly[1].name==undefined?"生活自理能力":item.zt_xp_sum_ly[1].name}}
                </template>
                {{ item.zt_xp_sum_ly[1].value==undefined?"0":item.zt_xp_sum_ly[1].value }}分
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  {{item.zt_xp_sum_ly[2].name==undefined?"社会适应能力":item.zt_xp_sum_ly[2].name}}
                </template>
                {{ item.zt_xp_sum_ly[2].value==undefined?"0":item.zt_xp_sum_ly[2].value }}分
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  {{"第"+"一二三".charAt(item.zt_xp_tab)+"次评估总分"}}
                </template>
                {{ item.zt_sum==undefined?"0":item.zt_sum }}分
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  评估时间
                </template>
                {{ item.zt_xp_time==undefined?"空":item.zt_xp_time}}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-user"></i>
                  训练人员
                </template>
                {{ item.zt_xp_teacher==undefined?"未签字":item.zt_xp_teacher}}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <div v-else>
          <el-empty description="暂无数据"></el-empty>
        </div>
      </el-card>

      <!-- 康复目标计划 -->
      <div style="height: 50px;width: 200px;"></div>
      <el-card id="id3">
        <span v-for="(item,index) in mb_jh_list" :key="index">
          <div class="el-descriptions__title margin-top" style="font-size:22px;">
            {{'初中末'.charAt(item.zt_mb_dq)+'期康复'}}
          </div>
          <el-descriptions class="margin-top" title="康复目标" :column='2' border>

            <el-descriptions-item v-for="(item1,index1) in item.kf_mubiao" :key="index1">
              <template slot="label">
                <i class="el-icon-user"></i>
                {{item1.name}}
              </template>
              {{item1.value}}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions class="margin-top" title="项目" :column='2' border>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练项目
              </template>
              <span v-for="(item1,index1) in item.xl_xiangmu" :key="index1">
                {{item1+","}}
              </span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                康复项目
              </template>
              <span v-for="(item1,index1) in item.kf_xiangmu" :key="index1">
                {{item1+","}}
              </span>
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column='3' border>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练人员
              </template>
              {{item.kf_teacher}}
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                家长确认
              </template>
              {{item.kf_jiazhang=='1'?"已确认":"未确认"}}
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                制定日期
              </template>
              {{item.data_time_kf}}
            </el-descriptions-item>
          </el-descriptions>
        </span>

      </el-card>
      <div style="height: 50px;width: 200px;"></div>
      <!-- 家长培训记录 -->
      <el-card id="id5">
        <div slot="header" class="clearfix">
          <span>家长培训记录</span>

        </div>
        <div>
          <el-table :data="jiazhang" border>
            <el-table-column prop="date" label="日期">
            </el-table-column>
            <el-table-column prop="Training_content" label="培训内容">
            </el-table-column>
            <el-table-column prop="Duration" label="时长">
            </el-table-column>
            <el-table-column prop="Teacher" label="授课老师">
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card id="id7">
				<div slot="header" class="clearfix">
					<span>课程信息</span>

				</div>
				<div>
					<el-table :data="kecheng"  >
						<el-table-column prop="week_ke" label="上课周次">
						</el-table-column>
						<el-table-column prop="curriculum_name" label="课程名称">
						</el-table-column>
						<el-table-column prop="curriculum_classification" label="课程分类">
						</el-table-column>
						<el-table-column prop="curriculum_teacher" label="授课老师">
						</el-table-column>
						<el-table-column  prop="start_time" label="上课开始时间">
    					</el-table-column>
						<el-table-column  prop="end_time" label="上课结束时间">
    					</el-table-column>
						<el-table-column  prop="org_name" label="所在机构">
    					</el-table-column>
					</el-table>
				</div>
			</el-card>
      <div style="height: 50px;width: 200px;"></div>

      <!-- 康复训练记录 -->
      <el-card id="id4">
        <div slot="header" class="clearfix">
          <span>康复训练记录</span>

        </div>
        <div>
          <el-table :data="kf_pxjl" border>
            <el-table-column prop="yue_name" label="日期(月)">
            </el-table-column>
            <el-table-column prop="week" label="周次">
              <template slot-scope='data'>
                <span>第{{"一二三四".charAt(Number.parseInt(data.row.week-1))}}周</span>
              </template>
            </el-table-column>
            <el-table-column prop="week_time" label="周次日期">
            </el-table-column>
            <el-table-column prop="value" label="训练内容">
            </el-table-column>
            <el-table-column prop="teacher" label="训练人员">
            </el-table-column>
          </el-table>
        </div>
        <div style="height: 50px;width: 200px;"></div>
        <!-- 评估与总结 -->
        <el-card id="id6">
          <div slot="header" class="clearfix">
            <span>评估与总结</span>
          </div>

          <el-descriptions title="初期评估" :column='2' border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                初期评估分数
              </template>
              {{pxzj_list.pg_fs_cc=="null"?'0':pxzj_list.pg_fs_cc}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                填写日期
              </template>
              {{pxzj_list.data_time0}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                目前主要存在的功能障碍和困难情况
              </template>
              {{pxzj_list.cq_knqk}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                康复训练计划
              </template>
              {{pxzj_list.cq_kfjh}}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions class="margin-top" title="中期一次评估" :column='2' border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                中期一次评估分数
              </template>
              {{pxzj_list.pg_fs_zy=="null"?'0':pxzj_list.pg_fs_zy}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                提高分数
              </template>
              {{pxzj_list.tg_zy}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练人员
              </template>
              {{pxzj_list.teacher1}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                填写日期
              </template>
              {{pxzj_list.data_time1}}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                小结训练计划执行情况、训练对象当前的主要功能和障碍、训练中存在的问题及训练计划进行了哪些调整
              </template>
              {{pxzj_list.zy_tz}}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions class="margin-top" title="中期二次评估" :column='2' border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                中期二次评估分数
              </template>
              {{pxzj_list.pg_fs_zr=="null"?'0':pxzj_list.pg_fs_zr}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                提高分数
              </template>
              {{pxzj_list.tg_zr}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练人员
              </template>
              {{pxzj_list.teacher2}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                填写日期
              </template>
              {{pxzj_list.data_time2}}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                小结训练计划执行情况、训练对象当前的主要功能和障碍、训练中存在的问题及训练计划进行了哪些调整
              </template>
              {{pxzj_list.zr_tz}}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions class="margin-top" title="末期评估" :column='2' border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                末期评估分数
              </template>
              {{pxzj_list.pg_fs_mq=="null"?'0':pxzj_list.pg_fs_mq}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                提高分数
              </template>
              {{pxzj_list.tg_mo}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                初次至末期评估提高分数
              </template>
              {{pxzj_list.tg_cdm}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练效果
              </template>
              {{pxzj_list.xlxg}}分
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                实现康复目标情况
              </template>
              <span v-for="(item2,index2) in pxzj_list.kfmbqk" :key="index2">
                {{item2.value+"; "}}
              </span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                进一步康复意见
              </template>
             <span v-for="(item2,index2) in pxzj_list.jybyj" :key="index2">
               {{item2+"; "}}
             </span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                训练人员
              </template>
              {{pxzj_list.teacher3}}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                填写日期
              </template>
              {{pxzj_list.data_time3}}
            </el-descriptions-item>
          </el-descriptions>

        </el-card>

      </el-card>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisiblev1" width="30%" :before-close="handleClose11">
			<span>点击可放大查看</span>
			<div class="demo-image__preview">
				<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="imgList">
				</el-image>
			</div>
			<el-button @click="dialogVisiblev1 = false">取 消</el-button>
			<el-button type="primary" @click="dialogVisiblev1 = false">确 定</el-button>
		</el-dialog>
    <div class="rbuttong">
      <el-date-picker style="width: 8vw; margin-right: -15px;" v-model="date_time_year" type="year" placeholder="切换年份">
      </el-date-picker>
      <el-button @click="scrollT('id1')"
        style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;">基本资料信息</el-button>
      <el-button @click="scrollT('id2')" style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
        class="rbtn">训练评估</el-button>
      <el-button @click="scrollT('id3')" style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
        class="rbtn">康复目标计划</el-button>
      <el-button @click="scrollT('id5')"
        style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;">家长培训记录</el-button>
        <el-button @click="scrollT('id7')"
        style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;">课程信息</el-button>
      <el-button @click="scrollT('id4')" style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
        class="rbtn">康复训练记录</el-button>
      <el-button @click="scrollT('id6')" style="margin-right: -15px; width: 8vw;margin-top: 10px;margin-left: 0px;"
        class="rbtn">评估与总结</el-button>

    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        // 家长培训照片弹窗
			  dialogVisiblev1: false,
			  url:'',
			  imgList:[],
        stu_id: null,
        stu_type: "",
        stu_name: '',
        kf_pxjl: [],
        // 基本信息
        stu_info_zt: {},
        pxzj_list: {},
        stu_xp: null,
        year:'',
        famliy_info: [],
        jiazhangneme: '',
        jiazhang: [],
        date_time_year:'',
        mb_jh_list: [],
        kecheng:[],
        org_id: null
      }
    },
    created() {
      var urlParams = new URLSearchParams(window.location.search);
      this.stu_id = urlParams.get('stuid')
      this.org_id = urlParams.get('org_id')
      this.stu_type = urlParams.get('stu_type')
      this.stu_name = urlParams.get('stu_name')
      this.year = new Date(urlParams.get('nian')).getFullYear()
      this.date_time_year = urlParams.get('nian')
      this.get_dangan()
      this.getkecheng()
    },
    computed:{
      teatoken(){
        return window.localStorage.getItem("tea_token")
      }
    },
    watch: {
      date_time_year() {
        let data = new Date(this.date_time_year)
        this.year = data.getFullYear()
        this.get_dangan()
      }
    },
    methods: {
      async getkecheng(){
			let res = await axios.get(this.$urls + 'mubiao_y/stu_class_info', {
				params: {
					qx:'"all"',
              		stu_id:this.stu_id,
              		year:this.years1
				},headers: {
				"teatoken": this.teatoken
			
				}
			});
			this.kecheng=res.data.cha
			
		},
      handleClose11(){
			this.dialogVisiblev1=false
		},
		seeimg(e,a){
			if(a.ptr_img!="null"||a.ptr_img.length!=0){
				this.dialogVisiblev1=true
				this.imgList=[]
				this.url=this.jiazhang[e].ptr_img[0]
				for(let a =0;a<this.jiazhang[e].ptr_img.length;a++){
					this.imgList.push(this.jiazhang[e].ptr_img[a])
				}
			}else{
				
			}
			
		},
      scrollT(id) {
        setTimeout(() => {
          let idd = document.getElementById(id)
          idd.scrollIntoView()
        }, 80)
      },
      get_dangan() {
        
      console.log(this.stu_type,'00000000');
        this.$axios.get(this.$urls + "test/get_dangan_stu", {
          params: {
            stu_id: this.stu_id,
            stu_type: this.stu_type.split(",")[0],
            year: this.year,
            org_id: this.org_id
          },headers: {
				"teatoken": this.teatoken
			
				}
        }).then((reposne) => {
          console.log(reposne.data,'reposne.data');
          this.stu_info_zt = {}
          this.stu_x = null
          this.famliy_info = []
          // 基本信息 处理
          let list = reposne.data.data
          let obj_info = list.find(item => item.name == "基本资料").value
          if (obj_info) {
            for (let key in obj_info) {
              let info = obj_info[key]
              if (info == null || info == undefined || info == 'null' || info == 'undefined' || info.length == 0) {
                if (key != 'stu_zd_img') {
                  obj_info[key] = '暂无数据'
                } else {
                  obj_info[key] = '1'
                }
              }
            }
            if (obj_info.stu_ID != "暂无数据") {
              obj_info.age = new Date().getFullYear() - Number.parseInt(obj_info.stu_ID.substring(6, 10))
              obj_info.shengri = obj_info.stu_ID.substring(6, 10) + "-" + obj_info.stu_ID.substring(10, 12) + "-" +
                obj_info.stu_ID.substring(12, 14)
              obj_info.stu_sex = Number.parseInt(obj_info.stu_ID.substr(16, 1)) % 2 == 0 ? '女' : '男'
            }
            this.stu_info_zt = obj_info
            this.jiazhangneme = this.stu_info_zt.jhonename
            let lists = [{
              guanxi: "父亲",
              name: this.stu_info_zt.jhonename,
              idcard: this.stu_info_zt.jhonephone,
              phone: this.stu_info_zt.jhoneidcard,
            }, {
              guanxi: "母亲",
              name: this.stu_info_zt.jhtwoname,
              idcard: this.stu_info_zt.jhtwophone,
              phone: this.stu_info_zt.jhtwoidcard,
            }]
            this.famliy_info = lists

          }
          // 训练评估
          let obj_xp = list.find(item => item.name == "训练评估").value
          if (obj_xp) {
            obj_xp.map((e, i) => {
              obj_xp[i].zt_xp_sum_ly = JSON.parse(e.zt_xp_sum_ly)
              obj_xp[i].zt_conent_ly = JSON.parse(e.zt_conent_ly)
            })
          }
          this.stu_xp = obj_xp
          // 目标计划
          this.mb_jh_list = []
          let mb_jh = list.find(item => item.name == "康复目标计划").value
          if (mb_jh) {
            mb_jh.map((e, r) => {
              mb_jh[r].xl_xiangmu = JSON.parse(mb_jh[r].xl_xiangmu.replace(/\n/g, '; '))
              mb_jh[r].kf_xiangmu = JSON.parse(mb_jh[r].kf_xiangmu.replace(/\n/g, '; '))
              mb_jh[r].kf_mubiao = JSON.parse(mb_jh[r].kf_mubiao.replace(/\n/g, '; '))
            })
            this.mb_jh_list = mb_jh
          }
          // 家长培训
          this.jiazhang = []
          let jz = list.find(item => item.name == "家长培训").value
          console.log(jz,"jzjzjzjzjzjzjz");
          if (jz) {

            this.jiazhang = jz
          }
          // 康复训练记录
          this.kf_pxjl = []
          let pxjl = list.find(item => item.name == "康复训练记录").value
          if (pxjl) {
            this.kf_pxjl = pxjl
          }
          console.log(this.kf_pxjl,'0000000000000000000000');
          // 评估与总结
          this.pxzj_list = {}
          let pxzj = list.find(item => item.name == "评估与总结").value
          if (pxzj) {
            this.pxzj_list = pxzj
            this.pxzj_list.jybyj = JSON.parse(this.pxzj_list.jybyj.replace(/\n/g, '; '))
            this.pxzj_list.kfmbqk = JSON.parse(this.pxzj_list.kfmbqk.replace(/\n/g, '; '))
            console.log(this.pxzj_list, '1111111111111');
          }
        })
      }
    }
  }
</script>

<style type="text/css">
  .queren {
    display: flex;
    align-items: center;
  }

  .rbuttong {
    position: fixed;
    right: 5px;
    width: 12vw;
    top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .dbod {
    width: 80vw;
    margin-left: 5vw;
  }

  .margin-top {
    margin-top: 10px;
  }
</style>